'use client';

import { useEffect } from 'react';
import { IPageMetadata } from '@app-types/nextjs';
import { useAnalytics } from '@domain/analytics/AnalyticsContext';

type IProps = {
  blockDatadogRum?: boolean;
  pageProps: IPageMetadata;
};

export function AnalyticsUpdater({ blockDatadogRum, pageProps }: IProps) {
  const { setCurrentPage, setBlockDatadogRum } = useAnalytics();

  useEffect(() => {
    setCurrentPage({
      ...pageProps,
    });
  }, [pageProps, setCurrentPage]);

  useEffect(() => {
    setBlockDatadogRum(!!blockDatadogRum);
  }, [blockDatadogRum, setBlockDatadogRum]);

  return null;
}
